import script from "./VouchersSearchPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./VouchersSearchPage.vue?vue&type=script&setup=true&lang=ts"

import "./VouchersSearchPage.vue?vue&type=style&index=0&id=6a1deeec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a1deeec"]])

export default __exports__